import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';

import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TimeSlots from '../../../Shared/TimeSlots/TimeSlots';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setIsSubmit, setSelectedDeliveryDay, setSelectedDeliveryTime, reportDWH, setSupplyByPost } from '../saleJetBlockSlice';
import { getCustomerAddresses, getTechnicianTimesAsync, getDeliveryTimeSlots } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import likeIcon from '../../../Shared/TimeSlots/images/icon-24-like.svg';
import Image from 'app/Components/Shared/Image/image';
const DeliveryPage = (props) => {

  useEffect(() => {
    props.reportDWH({ actionType: 'Select Delivery Date', status: 'Ongoing', messageText: 'Select Delivery Date Page Displayed' });
    gtag4({
      event: props.saleType == "cellular" ? 'cellular_Step11_DeliveryPage' :  `${props.saleType}_Step6_DeliveryPage'`,
      step: props.saleType == "cellular" ? '11' : '6',
      action: 'DeliveryPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      props.getDeliveryTimeSlots();
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = props.saleType == 'cellular' ?  'בואו נתקדם' : 'המשך' ;
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  let deliveryTitle = "המשלוח חינם";
  const toggleLinkStyle = { color: "var(--theme-primary, #9631ff)", fontSize: '16px', textAlign: 'center', textDecoration: 'underline', display: 'block', marginTop: '14px' };
  const displayTechnicianLink = props.saleType != 'cellular';
  //page params

  let currentPageHeadline = (

    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>

      {props.saleType == 'cellular' ?
        <>
          {props._authentication.loginData.isFullAuthenticated ? (
            <h1 className='sale-title-big'>היי  {props._authentication.loginData.userDetails.firstName} , מתי להגיע עם ה-SIM?</h1>
          ) : (
            <h1 className='sale-title-big'> מתי להגיע עם ה-SIM?</h1>
          )
          }
          <h2 className='sale-title-small'>השליח שלנו יגיע ל<span>{props.deliveryAddress.streetName} {props.deliveryAddress.home} , {props.deliveryAddress.cityName}</span></h2>
          <h2 className='sale-title-small'><a href="#" onClick={() => handleOnChangeAddress()}>לשינוי הכתובת</a></h2>

        </> :
        <>
          {props._authentication.loginData.isFullAuthenticated ? (
            <h1 className='sale-title-big'>{props._authentication.loginData.userDetails.firstName}, שליח יוכל להגיע אליך כבר <br /> ביום {props.titleDeliveryPage} </h1>
          ) : (
            <h1 className='sale-title-big'>שליח יוכל להגיע אליך כבר <br /> ביום {props.titleDeliveryPage} </h1>
          )
          }

          <h2 className='sale-title-small'> לשינוי יש לבחור את היום והשעה הנוחים לך </h2>
        </>
      }

      <h3 className='sale-title-small-purple like-icon'><Image src={likeIcon} alt="like" className="like-icon" />{deliveryTitle}</h3>
    </div>
  );

  let currentPageView = (
    <div>
      <TimeSlots technicianTimes={props.deliveryTimeSlots} onSelectDay={handleSelectDay} onSelectHours={handleSelectHours} />
      {props.saleType == 'cellular' &&
      <div className='supply-by-post-checkbox-wrapper'>
        <CheckBox
          id={'supply-by-post-checkbox'}
          checked={props.isSupplyByPost}
          label={'תשאירו את ה-SIM בתיבת הדואר'}
          onChange={() => handleOnChangeSupplyByPostCheckbox()} />
      </div>}
      {displayTechnicianLink && <a href='#' style={toggleLinkStyle} onClick={() => goToTechnicianPage()}>התחרטתי, רוצה לקבוע טכנאי</a>}
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinueAfterValid() {
    props.reportDWH({ actionType: 'Select Delivery Date', status: 'Ongoing', messageText: 'Select Delivery Date Button Clicked' });
    gtag4({
      event: props.saleType == "cellular" ? 'cellular_Step11_DeliveryContinueButton' :  `${props.saleType}_Step6_DeliveryContinueButton'`,
      step: props.saleType == "cellular" ? '11' : '6',
      button: btnText,
      action: 'DeliveryContinueButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
    /*
    if (props.saleCatalog.pavingFee?.price && parseFloat(props.saleCatalog.pavingFee?.price) > 0) {
      props.goToPage('pavingFeePage');
    }
    else {
      if (props.flowType == 'existsCustomer') {
        props.getCustomerAddresses();
      } else {
        props.goToPage('personalInfoPage');
      }
    }
    */

    if (props.saleType == 'cellular') {
      if (props.flowType == 'existsCustomer') {
        props.goToPage('emailPage');
      }
      else {
        props.goToPage('summaryPage');
      }
    }
    else {
      if (props.flowType == 'existsCustomer') {
        props.getCustomerAddresses();
      } else {
        props.goToPage('personalInfoPage');
      }
    }
  }

  function handlePageContinue() {
    props.reportDWH({ actionType: 'Delievery Page', status: 'Ongoing', messageText: 'Delievey Date Button Clicked' });
    if (props.selectedDeliveryDate) {
      handlePageContinueAfterValid();
    }
  }

  function handleSelectDay(data) {
    props.setSelectedDeliveryDay(data);
  }

  function handleSelectHours(data) {
    props.setSelectedDeliveryTime(data);
  }

  function goToTechnicianPage() {
    props.getTechnicianTimesAsync();
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function handleOnChangeAddress() {
    props.reportDWH({ actionType: 'Delievery Page', status: 'Ongoing', messageText: 'Change Adress Clicked' });
    gtag4({
      event:  'cellular_Step11_DeliveryUpdateAddressButton' ,
      step: '11' ,
      button: 'לשינוי הכתובת',
      action: 'DeliveryUpdateAddressButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
    props.goToPage('deliveryAddressPage');
  }

  function handleOnChangeSupplyByPostCheckbox() {
    props.reportDWH({ actionType: 'Delievery Page', status: 'Ongoing', messageText: 'Leave in Mail Clicked' });
    props.setSupplyByPost(!props.isSupplyByPost);
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    isSubmit: state.saleJetBlock.isSubmit,
    saleCatalog: state.saleJetBlock.saleCatalog,
    deliveryTimeSlots: state.saleJetBlock.delivery.timeSlots,
    selectedDeliveryDate: state.saleJetBlock.delivery.selectedDeliveryDate,
    titleDeliveryPage: state.saleJetBlock.delivery.titleDeliveryPage,
    deliveryAddress: state.saleJetBlock.delivery.selectedAddress,
    isKosherSubscriber: state.saleJetBlock.checkUserResponse.isKosherSubscriber,
    collectEmailOnProcess: state.saleJetBlock.checkUserResponse.collectEmailOnProcess,
    isSupplyByPost: state.saleJetBlock.cellular.isSupplyByPost,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setSelectedDeliveryDay,
  setSelectedDeliveryTime,
  getCustomerAddresses,
  getTechnicianTimesAsync,
  getDeliveryTimeSlots,
  reportDWH,
  setSupplyByPost
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryPage);
